// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"66":"f3eabd18","239":"e39fb35b","455":"1b991356","977":"4b3215a8"}[chunkId] + ".chunk.js";
};